<template>
  <my-modal>
    <div class="modal-container">
      <div class="modal-header text-center">
        <h3 class="text-center">Ver capitalización</h3>
        <button type="button" class="close" @click="cerrarModal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        class="modal-body justify-content-center"
        style="max-height:100%!important;height:auto!important;overflow:visible;"
      >
        <div class="row w-100">

          <float-label label="Marca:" clase="col-md-6 col-12">
            <select v-model="marca" id="marca_id" class="form-control">
              <option :value="null">Todo</option>
              <option
                v-for="marca in marcas"
                :key="marca.id"
                :value="marca.id"
              >{{marca.descripcion}}</option>
            </select>
          </float-label>
          <div class="col-md-6">
            <button class="btn btn-info btn-block p-2" @click="verCapitalizacion">Ver</button>
          </div>
        </div>
      </div>
      <div v-if="searched" class="row w-100">
        <div class="col-12 text-center pt-2 pb-4">
          <h5>Capitalización: ${{capitalizacion}}</h5>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="row w-100">
          <div class="col-md-4">
            <button class="btn btn-danger btn-block mb-2" @click="cerrarModal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import MyModal from "@/components/layouts/MyModal.vue";
import FloatLabel from "@/components/layouts/FloatLabel.vue";
import axios from "axios";
export default {
  name: "ModalCapitalizacion",
  components: {
    MyModal,
    FloatLabel
  },
  data() {
    return {
      marca: null,
      marcas: [],
      capitalizacion: 0,
      searched: false
    };
  },
  created(){
    const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
      this.cerrarModal()
      next(false)
    })

    this.$once('hook:destroyed', () => {
      unregisterRouterGuard()
    })
  },
  mounted() {
    this.getMarcas();
  },
  methods: {
    getMarcas() {
      axios.get("/marcas").then(res => {
        for (let marca of res.data.data) {
          this.marcas.push(marca);
        }
      });
    },
    verCapitalizacion(){
      axios.get('capitalizacion', {params: {marca: this.marca}})
        .then((res) => {
          if(res.data.success){
            this.searched = true
            const formatter = new Intl.NumberFormat("de-DE")
            this.capitalizacion = formatter.format(res.data.capitalizacion)
          }
        })
    },
    cerrarModal() {
      this.$emit("cerrarModalCapitalizacion");
    },
  }
};
</script>


<style scoped>

</style>
